// manage listeners within AG Gridconst manageGridEventListeners = (gridRef, debouncedSaveColumnState) => {

import { AgGridReact } from "ag-grid-react";
import { updateOpenWidgetsWithTableConfigs } from "./widgetHelperFunctions";

export const manageGridEventListeners = (
  gridRef: React.RefObject<AgGridReact<any>>,
  debouncedSaveColumnState: () => void,
) => {
  if (gridRef.current) {
    const gridApi = gridRef.current.api;

    // Add event listeners
    gridApi.addEventListener("columnResized", debouncedSaveColumnState);
    gridApi.addEventListener("sortChanged", debouncedSaveColumnState);
    gridApi.addEventListener("columnVisible", debouncedSaveColumnState);
    gridApi.addEventListener("filterChanged", debouncedSaveColumnState);
    gridApi.addEventListener("columnMoved", debouncedSaveColumnState);

    // Return a cleanup function
    return () => {
      if (gridRef.current) {
        const gridApi = gridRef.current.api;
        gridApi.removeEventListener("columnResized", debouncedSaveColumnState);
        gridApi.removeEventListener("sortChanged", debouncedSaveColumnState);
        gridApi.removeEventListener("columnVisible", debouncedSaveColumnState);
        gridApi.removeEventListener("filterChanged", debouncedSaveColumnState);
        gridApi.removeEventListener("columnMoved", debouncedSaveColumnState);
      }
    };
  }
  return () => {}; // Fallback cleanup function if gridRef.current is not available
};

export function readGridRefAndUpdateStoreAndDatabaseWithNewValues(
  gridRef: React.RefObject<AgGridReact<any>>,
  getAccessTokenSilently: Function,
  cryptoID?: string | undefined,
  // Persist this instead of the live grid filter — lets callers keep a saved filter that isn't
  // restored yet (e.g. empty table on load, where getFilterModel() is {}). Omit for normal saves.
  filterModelOverride?: { [colId: string]: any },
) {
  if (gridRef && gridRef.current) {
    const columnState = gridRef.current.api.getColumnState();

    const columnStateForWidget = columnState
      .filter((row) => row.colId !== "filler")
      .map((row) => {
      // THIS IS WHAT WILL GET SAVED TO THE STATE JSON
      return {
        colId: row.colId,
        width: row.width,
        hide: row.hide,
        sort: row.sort,
        pinned: row.pinned,
        rowGroup: row.rowGroup,
        rowGroupIndex: row.rowGroupIndex,
      };
    });

    // Adding the filter model to the state JSON also allows restorable filters.
    const filterModel =
      filterModelOverride ?? gridRef.current.api.getFilterModel();

    updateOpenWidgetsWithTableConfigs({
      cryptoID,
      columnStateForWidget,
      filterModel,
      getAccessTokenSilently,
    });
  }
}

export function applyFiltersToAGGridTable(
  gridRef: React.RefObject<AgGridReact<any>>,
  openWidgetObject: any,
) {
  if (openWidgetObject && gridRef) {
    if (
      gridRef.current &&
      gridRef.current.api &&
      openWidgetObject.filterModel
    ) {
      // Virtual Dom columns are used as a safeguard against fast UI changed through the workspaces tabs.
      // If the virtual cols are undefined, the grid api is possilby old.
      const currentVirtualColumns =
        gridRef.current?.api.getAllDisplayedVirtualColumns();
      if (currentVirtualColumns) {
        if (gridRef && gridRef.current && gridRef.current.api) {
          if (JSON.stringify(openWidgetObject.filterModel) != "{}") {
            gridRef.current.api.setFilterModel(openWidgetObject.filterModel);
          }
        }
      } // Gives time for headers such at Structure to load.
    }
  }
}

export function applyColumnStateToAGGridTable(
  gridRef: React.RefObject<AgGridReact<any>>,
  openWidgetObject: any,
) {
  if (
    gridRef.current &&
    openWidgetObject &&
    openWidgetObject.columnStateForWidget
  ) {
    gridRef.current.api.applyColumnState({
      state: openWidgetObject.columnStateForWidget,
      applyOrder: true,
      defaultState: { sort: null }, // Clear sort on columns not in the state
    });

    // Ensure filler column retains flex behavior after state restoration
    gridRef.current.api.applyColumnState({
      state: [{ colId: "filler", flex: 1 }],
    });
  }
}
